
window.addEventListener('load', () => {
    const maintenanceFourMonthForm = document.getElementById('maintenanceFourMonth');

    if (maintenanceFourMonthForm) {
        const MAX_4MONTH_FORM_ROWS = 15;
        let maintenanceItemField = null;
        let maintenanceItemListField = null;
        let maintenanceItemRow = null;
        let uniqueCounter = 0;
        let addRowButton;

        const updateAddRowButton = () => {
            const rowCount = maintenanceFourMonthForm.querySelectorAll('[name^="maintenanceItem"]:not(#form-input-maintenanceItemList)').length;
            addRowButton.innerText = `+ Maintenance Item`;

            if (rowCount >= MAX_4MONTH_FORM_ROWS) {
                addRowButton.disabled = true;
                addRowButton.classList.add('disabled');
            } else {
                addRowButton.disabled = false;
                addRowButton.classList.remove('disabled');
            }
        };

        const cloneMaintenanceItemRow = () => {
            const newRow = maintenanceItemRow.cloneNode(true);
            const label = newRow.querySelector('label');
            const input = newRow.querySelector('textarea');

            const uniqueIndex = (++uniqueCounter).toString().padStart(2,'0');
            const uniqueId = `form-input-maintenanceItem${uniqueIndex}`;
            const uniqueName = `maintenanceItem${uniqueIndex}`;

            label.setAttribute('for',uniqueId);
            input.id = uniqueId;
            input.name = uniqueName;
            input.value = '';
            input.classList.add('pr-8')

            const deleteButton = document.createElement('button');
            deleteButton.type = 'button';
            deleteButton.innerText = '✕';
            deleteButton.className = 'absolute right-[2px] w-8 top-0 h-full text-white bg-gray-2 text-xs transition-color duration-300 ease-in-out hover:bg-gray-1';

            deleteButton.addEventListener('click', () => {
                newRow.parentElement.removeChild(newRow);

                updateAddRowButton();
            });

            input.parentElement.appendChild(deleteButton);

            return newRow;
        };

        const initForm = () => {
            // Reset values
            maintenanceItemField = maintenanceFourMonthForm.querySelector('#form-input-maintenanceItem01');
            maintenanceItemListField = maintenanceFourMonthForm.querySelector('#form-input-maintenanceItemList');
            maintenanceItemRow = maintenanceItemField.closest('.freeform-row');
            uniqueCounter = 0;

            // Setup our add row button
            const buttonRow = cloneMaintenanceItemRow();
            addRowButton = document.createElement('button');
            addRowButton.type = 'button';
            addRowButton.classList.add('text-black', 'bg-yellow-brand', 'hover:brightness-110', 'transition-[color,background,transform,opacity,filter]', 'duration-300', 'ease-in-out', 'active:translate-y-[0.125rem]', 'active:duration-75', 'font-medium', 'h-12', 'min-h-[3rem]', 'w-full', 'sm:w-max', 'px-5', 'py-3', 'flex', 'items-center', 'justify-center', 'gap-2', 'text-center', 'no-underline', 'hover:no-underline', 'active:no-underline', '!no-underline', 'whitespace-nowrap', 'pointer-events-auto', 'group/cta', 'disabled:bg-gray-2', 'disabled:hover:brightness-100', 'disabled:!translate-y-0', 'disabled:text-white')

            // Click handler to delete own row
            addRowButton.addEventListener('click', () => {
                const newRow = cloneMaintenanceItemRow();

                maintenanceItemRow.parentElement.insertBefore(newRow, buttonRow);
                newRow.querySelector('textarea').focus();

                updateAddRowButton();
            });

            // Delete the contents from the cloned row and add our button
            buttonRow.firstElementChild.innerHTML = '';
            buttonRow.firstElementChild.appendChild(addRowButton);
            updateAddRowButton();

            // Insert our row into the form
            maintenanceItemRow.parentElement.insertBefore(buttonRow, maintenanceItemRow.nextElementSibling);
        }

        maintenanceFourMonthForm.addEventListener('freeform-ready', initForm);

        maintenanceFourMonthForm.addEventListener("freeform-on-submit", function (event) {
            const maintenanceItemData = [];

            maintenanceFourMonthForm.querySelectorAll('textarea[name^="maintenanceItem"]').forEach((maintenanceItemField) => {
                maintenanceItemData.push(maintenanceItemField.value);
            });

            // Force everyone to always be a Smith
            maintenanceItemListField.value = JSON.stringify(maintenanceItemData);
        });

        // Setup a mutation observer so that, when freeform re-renders after a successful submission, we re-add our customisations
        const observer = new MutationObserver((mutations) => {
            if (maintenanceFourMonthForm.parentElement.getAttribute('data-form-complete') === 'false') {
                initForm();
            }
        });

        observer.observe(maintenanceFourMonthForm.parentElement, {
            attributes: true,
            attributeFilter: ['data-form-complete']
        });
    }

    document.querySelectorAll('#maintenanceSixYear,#maintenanceTenYear').forEach((maintenanceForm) => {
        let maintenanceItemRows;
        let currIndex = 0;

        const initFormModifiers = () => {
            currIndex = 0;
            maintenanceItemRows = [...maintenanceForm.querySelectorAll('textarea[id^="form-input-maintenanceItem"]')].map((maintenanceItemField) => maintenanceItemField.closest('.freeform-row'));
            const headerElement = maintenanceItemRows[0].previousElementSibling;

            const buttonRow = maintenanceItemRows[0].cloneNode(true);
            buttonRow.removeChild(buttonRow.children[1]);

            maintenanceItemRows.forEach((maintenanceItemRow,index) => {
                if (index) {
                    maintenanceItemRow.style = 'display: none;';
                }

                maintenanceItemRow.setAttribute('data-row',index.toString());

                const deleteButton = document.createElement('button');
                deleteButton.type = 'button';
                deleteButton.innerText = '✕';
                deleteButton.className = 'w-8 top-0 h-full text-white bg-gray-2 text-xs transition-color duration-300 ease-in-out hover:bg-gray-1 transition-opacity opacity-0';

                deleteButton.addEventListener('click', () => {
                    const fileInput = maintenanceItemRow.querySelector('input[type="file"]');
                    const textInput = maintenanceItemRow.querySelector('textarea');

                    textInput.value = '';
                    fileInput.value = '';

                    if (!currIndex) {
                        return;
                    }

                    currIndex--;

                    const removeIndex = maintenanceItemRows.indexOf(maintenanceItemRow);
                    const removed = maintenanceItemRows.splice(removeIndex, 1);
                    removed.forEach((removedRow) => {
                        removedRow.style = 'display: none;'

                        // add back to the end
                        maintenanceItemRows.push(removedRow);
                    });

                    [...maintenanceItemRows].reverse().forEach((row) => {
                        headerElement.parentElement.insertBefore(row, headerElement.nextElementSibling);
                    });

                    updateAddRowButton();
                });

                maintenanceItemRow.lastElementChild.appendChild(deleteButton);
                maintenanceItemRow.lastElementChild.classList.add('flex');
            });

            const addRowButton = document.createElement('button');
            addRowButton.type = 'button';
            addRowButton.classList.add('text-black', 'bg-yellow-brand', 'hover:brightness-110', 'transition-[color,background,transform,opacity,filter]', 'duration-300', 'ease-in-out', 'active:translate-y-[0.125rem]', 'active:duration-75', 'font-medium', 'h-12', 'min-h-[3rem]', 'w-full', 'sm:w-max', 'px-5', 'py-3', 'flex', 'items-center', 'justify-center', 'gap-2', 'text-center', 'no-underline', 'hover:no-underline', 'active:no-underline', '!no-underline', 'whitespace-nowrap', 'pointer-events-auto', 'group/cta', 'disabled:bg-gray-2', 'disabled:hover:brightness-100', 'disabled:!translate-y-0', 'disabled:text-white')

            const updateAddRowButton = () => {
                const rowCount = currIndex+1;
                const rowsMax = maintenanceItemRows.length;
                addRowButton.innerText = `+ Maintenance Item`;

                if (rowCount >= rowsMax) {
                    addRowButton.disabled = true;
                    addRowButton.classList.add('disabled');
                } else {
                    addRowButton.disabled = false;
                    addRowButton.classList.remove('disabled');
                }

                maintenanceItemRows.forEach((row,index) => {
                    row.querySelectorAll('textarea,input').forEach((input) => {
                        input.required = !index;
                    });
                    const rowDeleteButton = row.querySelector('button');
                    rowDeleteButton.classList.toggle('opacity-100', currIndex !== 0);
                    rowDeleteButton.classList.toggle('pointer-events-none', currIndex === 0);
                });
            };

            // Click handler to delete own row
            addRowButton.addEventListener('click', () => {
                currIndex++;

                const nextRow = maintenanceItemRows[currIndex] ?? null;
                if (nextRow) {
                    nextRow.style = '';
                }

                updateAddRowButton();
            });

            // Delete the contents from the cloned row and add our button
            buttonRow.firstElementChild.innerHTML = '';
            buttonRow.firstElementChild.appendChild(addRowButton);
            updateAddRowButton();

            maintenanceForm.insertBefore(buttonRow, maintenanceItemRows[maintenanceItemRows.length-1].nextElementSibling);
        }

        initFormModifiers();

        // Setup a mutation observer so that, when freeform re-renders after a successful submission, we re-add our customisations
        const observer = new MutationObserver((mutations) => {
            if (maintenanceForm.parentElement.getAttribute('data-form-complete') === 'false') {
                initFormModifiers();
            }
        });

        observer.observe(maintenanceForm.parentElement, {
            attributes: true,
            attributeFilter: ['data-form-complete']
        });
    });
});